var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "licenseAddLicenseModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.add_license"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addLicense()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.create")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: { border: "0", padding: "0" },
        },
        [
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              attrs: { active: "" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-edit" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.general"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "license-name-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "true",
                      feedback: "true",
                      autofocus: "false",
                      label: _vm.$t("message.license_name"),
                      tooltip: this.$t("message.license_name_desc"),
                      "feedback-text": _vm.$t("message.required_license_name"),
                    },
                    model: {
                      value: _vm.license.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.license, "name", $$v)
                      },
                      expression: "license.name",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "license-id-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "true",
                      feedback: "true",
                      autofocus: "false",
                      label: _vm.$t("message.license_id"),
                      tooltip: this.$t("message.license_id_desc"),
                      "feedback-text": _vm.$t("message.required_license_id"),
                    },
                    model: {
                      value: _vm.license.licenseId,
                      callback: function ($$v) {
                        _vm.$set(_vm.license, "licenseId", $$v)
                      },
                      expression: "license.licenseId",
                    },
                  }),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "license-text-form-group",
                        label: this.$t("message.license_text"),
                        "label-for": "license-text-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: { id: "license-text-description", rows: "3" },
                        model: {
                          value: _vm.license.licenseText,
                          callback: function ($$v) {
                            _vm.$set(_vm.license, "licenseText", $$v)
                          },
                          expression: "license.licenseText",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "c-switch",
                    _vm._b(
                      {
                        staticClass: "mx-1",
                        attrs: { id: "input-5", color: "primary", label: "" },
                        model: {
                          value: _vm.license.isOsiApproved,
                          callback: function ($$v) {
                            _vm.$set(_vm.license, "isOsiApproved", $$v)
                          },
                          expression: "license.isOsiApproved",
                        },
                      },
                      "c-switch",
                      _vm.labelIcon,
                      false
                    )
                  ),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message.osi_approved")) + " "
                  ),
                  _c("br"),
                  _c(
                    "c-switch",
                    _vm._b(
                      {
                        staticClass: "mx-1",
                        attrs: { id: "input-5", color: "primary", label: "" },
                        model: {
                          value: _vm.license.isFsfLibre,
                          callback: function ($$v) {
                            _vm.$set(_vm.license, "isFsfLibre", $$v)
                          },
                          expression: "license.isFsfLibre",
                        },
                      },
                      "c-switch",
                      _vm.labelIcon,
                      false
                    )
                  ),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message.fsf_libre")) + " "
                  ),
                  _c("br"),
                  _c(
                    "c-switch",
                    _vm._b(
                      {
                        staticClass: "mx-1",
                        attrs: { id: "input-5", color: "primary", label: "" },
                        model: {
                          value: _vm.license.isDeprecatedLicenseId,
                          callback: function ($$v) {
                            _vm.$set(_vm.license, "isDeprecatedLicenseId", $$v)
                          },
                          expression: "license.isDeprecatedLicenseId",
                        },
                      },
                      "c-switch",
                      _vm.labelIcon,
                      false
                    )
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.deprecated")) +
                      "\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-newspaper-o" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.extended"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "license-comments-form-group",
                        label: this.$t("message.license_comments"),
                        "label-for": "license-comments-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "license-comments-description",
                          rows: "3",
                        },
                        model: {
                          value: _vm.license.licenseComments,
                          callback: function ($$v) {
                            _vm.$set(_vm.license, "licenseComments", $$v)
                          },
                          expression: "license.licenseComments",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "license-template-form-group",
                        label: this.$t("message.template"),
                        "label-for": "license-template-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "license-template-description",
                          rows: "3",
                        },
                        model: {
                          value: _vm.license.standardLicenseTemplate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.license,
                              "standardLicenseTemplate",
                              $$v
                            )
                          },
                          expression: "license.standardLicenseTemplate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "license-source-header-form-group",
                        label: this.$t("message.source_header"),
                        "label-for": "license-source-header-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "license-source-header-description",
                          rows: "3",
                        },
                        model: {
                          value: _vm.license.standardLicenseHeader,
                          callback: function ($$v) {
                            _vm.$set(_vm.license, "standardLicenseHeader", $$v)
                          },
                          expression: "license.standardLicenseHeader",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "license-see-also-form-group",
                        label: this.$t("message.see_also"),
                        "label-for": "license-see-also-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "license-see-also-description",
                          rows: "3",
                        },
                        model: {
                          value: _vm.license.seeAlso,
                          callback: function ($$v) {
                            _vm.$set(_vm.license, "seeAlso", $$v)
                          },
                          expression: "license.seeAlso",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }